// import 'firebase/auth'
import router from '@/router'
import AuthAPI from "@/network/api/AuthAPI";
import SsoAPI from "@/network/api/SsoAPI";
import AuditTrailAPI from "@/network/api/AuditTrailAPI";

export default {
    login({ state, dispatch }, payload) {
        // If user is already logged in notify and exit
        console.log("login")
        if (state.isUserLoggedIn()) {
            payload.notify({
                title: 'Login Attempt',
                text: 'You are already logged in!',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })

            console.log(router.currentRoute.query.continue)
            if (router.currentRoute.query.continue !== undefined) {
                dispatch('ssoAuthorize', {
                    redirect_uri: router.currentRoute.query.continue
                })
            } else {
                window.location.href = "/home"
            }
        } else {
            AuthAPI.Login(payload).then((result) => {
                dispatch('updateUsername', {
                    username: result.user.email,
                    notify: payload.notify,
                    isReloadRequired: true,
                    user: result.user,
                    roles: result.roles,
                    merchant: result.merchant,
                    access_token: result.access_token
                })

                AuthAPI.UserInfo().then(response => {
                    localStorage.setItem("merchantInfo", JSON.stringify(response.data.merchant[0]))
                })
            })
        }
    },
    // hide register
    // registerUser({ }, payload) {
    //     AuthAPI.Register(payload).then(() => {
    //         payload.notify({
    //             title: 'Account Created',
    //             text: 'Congratulations! You have successfully registered to AINO Platform',
    //             iconPack: 'feather',
    //             icon: 'icon-check',
    //             color: 'success',
    //             position: 'top-right'
    //         })

    //         router.push('/login')
    //     })
    // },
    updateUsername({ dispatch, commit }, payload) {
        // let newUserData = Object.assign({}, payload.user)
        // If reload is required to get fresh data after update
        // Reload current page
        if (payload.isReloadRequired) {
            commit('UPDATE_AUTHENTICATED_USER',
                {
                    id: payload.user.id,
                    displayName: payload.user.username,
                    email: payload.user.email,
                    phoneNumber: null,
                    photoURL: null,
                    providerId: "password",
                    uid: payload.user.email,
                    role: payload.roles[0],
                    access_token: payload.access_token,
                    merchant: payload.merchant
                })

            if (router.currentRoute.query.continue !== undefined) {
                AuthAPI.GetSessionID(payload.access_token.token).then((id) => {
                    localStorage.setItem("sessID", id)
                    // implements audit trail to login
                    AuditTrailAPI.CreateAuditTrail({
                        user_id: payload.user.id,
                        session_id: parseInt(id),
                        user_name: payload.user.username,
                        menu: "Login",
                    }).then(() => {
                        dispatch('ssoAuthorize', {
                            redirect_uri: router.currentRoute.query.continue
                        })
                    }, () => {
                        console.log("failed to save data")
                        dispatch('ssoAuthorize', {
                            redirect_uri: router.currentRoute.query.continue
                        })
                    })

                }, () => {
                    console.log("failed to get session_id")
                    dispatch('ssoAuthorize', {
                        redirect_uri: router.currentRoute.query.continue
                    })
                })
                return false
            } else {
                AuthAPI.GetSessionID(payload.access_token.token).then((id) => {
                    localStorage.setItem("sessID", id)
                    // implements audit trail to login
                    AuditTrailAPI.CreateAuditTrail({
                        user_id: payload.user.id,
                        session_id: parseInt(id),
                        user_name: payload.user.username,
                        menu: "Login",
                    }).then(() => {
                        if (payload.roles[0] == "issuer_user" ||
                            payload.roles[0] == "merchant_admin" ||
                            payload.roles[0] == "merchant_ops" ||
                            payload.roles[0] == "merchant_finance" ||
                            payload.roles[0] == "customer_service" ||
                            payload.roles[0] == "aino_pios" ||
                            payload.roles[0] == "aino_finance" ||
                            payload.roles[0] == "aino_recon" ||
                            payload.roles[0] == "aino_recon_child" ||
                            payload.roles[0] == "aino_cc" ||
                            payload.roles[0] == "administrator" ||
                            payload.roles[0] == "root"
                        ) {
                            window.location.href = process.env.VUE_APP_BACKOFFICE_WEBSITE_URL
                        } else {
                            window.location.href = "/home"
                        }
                    }, () => {
                        console.log("failed to save data")
                        window.location.href = "/home"
                    })

                }, () => {
                    console.log("failed to get session_id")
                    window.location.href = "/home"
                })
            }
        }
    },
    // single sign on request authorize
    ssoAuthorize({ state }, payload) {
        // If user is already logged in notify and exit
        console.log(state.isUserLoggedIn())
        if (state.isUserLoggedIn()) {
            SsoAPI.Authorize(payload).then((result) => {
                let code = result.data.code
                window.location = payload.redirect_uri + "/callback?code=" + code + "&user_login=" + JSON.parse(localStorage.getItem('userInfo')).email
            }, () => {
                router.push('/error/error-404')
            })
        }
    },
}


